import React, { useState } from 'react';
import { IBusyIndicatorProps } from './types';
import { useTimeout } from 'beautiful-react-hooks';
import styles from './BusyIndicator.module.css';

const BusyIndicator: React.FC<IBusyIndicatorProps> = ({
  text,
  fullScreen,
  delay,
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  useTimeout(() => setVisible(true), delay!);

  return (
    <div className={`${styles.container} ${fullScreen && styles.fullScreen}`}>
      {visible && (
        <>
          <i className="fas fa-spinner fa-spin fa-3x" />
          <span className={styles.text}>{text}...</span>
        </>
      )}
    </div>
  );
};

BusyIndicator.defaultProps = {
  fullScreen: false,
  delay: 500,
};

export default BusyIndicator;
